import { Route, Routes } from 'react-router-dom'
import UsersPage from '../../pages/shared-pages/users/UsersPage'
import UserDetailsPage from '../../pages/shared-pages/users/UserDetailsPage'

export default function UserNav() {
    return (
        <Routes>
            <Route path="/" element={<UsersPage />} />
            <Route path="/details" element={<UserDetailsPage />} />
        </Routes>
        )
}
